export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idlawyer: '',
        idprocesstype: '',
        idcliente: '',
        date_start: getCurrentDate(),
        initial_amount: '',
        initial_amount_mask: '',
        process_number: '',
        process_ministry: '',
        observations: '',
        flag_paid: '',
        date_paid: ''
    }
    
    const defaultFormOtherExpense = {
        idlawyerexpense: '',
        idlawyer: '',
        idexpense: '',
        amount: '',
        observation: ''
    }

    const defaultDiscountForm = {
        idlawyer: '',
        discount: ''
    }
    
    const defaultLawyerLogsForm = {
        idlawyer: '',
        date_log: getCurrentDate(),
        observations: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen,
        defaultFormOtherExpense,
        defaultDiscountForm,
        defaultLawyerLogsForm
    })
}